import { useEffect, useState } from 'react';

import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';
import PuffLoader from 'react-spinners/PuffLoader';
import { primaryColor } from '../../config/colors';
import useGetImage from '../../hooks/useGetImage';

import {
  ImageViewerWrapper,
  Image,
  FullScreenBtn,
  ImageAndFullScreenWrapper,
  PuffLoaderContainer,
  ImagePlaceholder,
} from './styles';

const ImageViewer = ({ imageId, containerStyle, fullscreen = true, customLoader, defaultLoaderSize = 100 }) => {
  const [fullScreenImage, setFullScreenImage] = useState(false);
  const { image: downloadedImage, isLoading: isImageLoading } = useGetImage(imageId);
  const [image, setImage] = useState(null);
  useEffect(() => {
    if (!downloadedImage) {
      return;
    }
    const base64ImageData = `data:image/jpeg;base64,${downloadedImage.data}`;
    setImage(base64ImageData);
  }, [downloadedImage]);

  if (isImageLoading) {
    return (
      <PuffLoaderContainer containerStyle={containerStyle}>
        {customLoader ? (
          customLoader
        ) : (
          <PuffLoader
            loading={true}
            size={defaultLoaderSize}
            color={primaryColor}
          />
        )}
      </PuffLoaderContainer>
    );
  }

  return (
    <>
      {fullScreenImage && fullscreen ? (
        <Lightbox
          image={image}
          title={downloadedImage.fileName}
          onClose={() => setFullScreenImage(false)}
        />
      ) : null}
      <ImageViewerWrapper
        style={containerStyle}
        draggable={false}>
        {image ? (
          <>
            <ImageAndFullScreenWrapper>
              <Image
                src={image}
                draggable={false}
              />
              {fullscreen && <FullScreenBtn onClick={() => setFullScreenImage(true)} />}
            </ImageAndFullScreenWrapper>
          </>
        ) : (
          <ImagePlaceholder />
        )}
      </ImageViewerWrapper>
    </>
  );
};

export default ImageViewer;
